/* Before & After — the grid layout only. The chips filter the cards by result kind and the
   load-more button reveals them a batch at a time.

   Both controls are rendered hidden and unhidden here, so with this file blocked the page
   still shows every card rather than controls that cannot do anything. Same arrangement as
   the journal's filter row. */

(function () {
  'use strict';

  function setup(grid) {
    var section = grid.closest('.before-and-after__section');
    if (!section) return;

    var cards = [].slice.call(grid.querySelectorAll('.before-and-after__card'));
    var filters = section.querySelector('.before-and-after__filters');
    var more = section.querySelector('.before-and-after__more');
    var batch = parseInt(grid.getAttribute('data-ba-batch'), 10) || cards.length;
    var category = '';
    var shown = batch;

    function matching() {
      return cards.filter(function (card) {
        return category === '' || card.getAttribute('data-ba-category') === category;
      });
    }

    function render() {
      var visible = matching();

      cards.forEach(function (card) { card.hidden = true; });
      visible.slice(0, shown).forEach(function (card) { card.hidden = false; });

      /* The button carries the whole "is there more" answer, so it disappears on the last
         batch and comes back when a wider filter puts cards out of reach again. */
      if (more) more.hidden = visible.length <= shown;
    }

    if (filters) {
      filters.hidden = false;

      filters.addEventListener('click', function (event) {
        var chip = event.target.closest('.before-and-after__filter');
        if (!chip) return;

        category = chip.getAttribute('data-ba-filter') || '';

        /* A new filter starts a new count. Carrying `shown` over would leave the grid
           showing more cards than a batch, and the button gone on a set that has more. */
        shown = batch;

        filters.querySelectorAll('.before-and-after__filter').forEach(function (button) {
          button.classList.toggle('is-active', button === chip);
        });

        render();
      });
    }

    if (more) {
      more.addEventListener('click', function (event) {
        if (!event.target.closest('[data-ba-more]')) return;
        shown += batch;
        render();
      });
    }

    render();
  }

  document.querySelectorAll('.before-and-after__grid').forEach(setup);
})();
